import React from 'react';
import {useNavigate} from 'react-router';

import {TFirebaseComp} from '@chancer/common/lib/interfaces/firestore/FirestoreClientInterfaces';
import {TCompStatusUpdated} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';
import {TabBar} from '../../../components/Layout/TabBar';

interface IProps {
  isAdmin: boolean;
  comp: TFirebaseComp;
  compStatus: TCompStatusUpdated;
  selected?: number;
}

export const CompPageHeader: React.FC<IProps> = (props) => {
  const navigate = useNavigate();
  const selected = props.selected || 0;
  const _handleTabChange = (index: number) => {
    if (index === 0) {
      navigate(`/admin/competitions/edit/${props.comp.id}`);
    } else if (index === 1) {
      navigate(`/admin/competitions/state/${props.comp.id}`);
    } else if (index === 2) {
      navigate(`/admin/competitions/leaderboards/${props.comp.id}`);
    } else if (index === 3) {
      navigate(`/admin/competitions/links/${props.comp.id}`);
    } else if (index === 4) {
      navigate(`/admin/competitions/notify/${props.comp.id}`);
    } else if (index === 5) {
      navigate(`/admin/competitions/chat/${props.comp.id}`);
    }
  };

  return props.comp.template !== true ? (
    <div className="mb-6">
      <TabBar
        selected={selected}
        tabs={[
          {name: 'Edit'},
          {name: 'Manage'},
          {name: 'Leaderboards'},
          {name: 'Links'},
          ...(props.isAdmin ? [{name: 'Notifications'}] : []),
          ...(props.isAdmin ? [{name: 'Chat Moderation'}] : []),
        ]}
        onChange={_handleTabChange}
      />
      {/* <div className="hidden sm:flex leading-6 text-sm mt-4 mb-6">
        {props.comp.qrCode && (
          <img src={props.comp.qrCode} className="h-20 w-auto mr-2" />
        )}
        <div>
          <a
            href={`https://${webDomain}/${props.comp.vendor}/${props.comp.key}/?comp=${props.comp.id}`}
            target="_blank">
            {`https://${webDomain}/${props.comp.vendor}/${props.comp.key}/?comp=${props.comp.id}`}
          </a>
          <br />
          <a
            href={`https://${webDomain}/${props.comp.vendor}/${props.comp.key}`}
            target="_blank">
            {`https://${webDomain}/${props.comp.vendor}/${props.comp.key}`}
          </a>
          <br />
          {props.comp.shortUrl && (
            <a href={props.comp.shortUrl} target="_blank">
              {props.comp.shortUrl}
            </a>
          )}
        </div>
      </div> */}
    </div>
  ) : null;
};
